// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshSubscriptions (state, subscriptions) {
    // set the quantity for the tables
    state.data = subscriptions
  },
  updateSubscription (state, subscription) {
    // set the quantity for the tables

    // see if we have an element with the same uid
    var existingElementIndex = state.data.findIndex((el) => el.uid === subscription.uid)
    // replace the existing one with the new one
    if (existingElementIndex > -1) {
        state.data.splice(existingElementIndex, 1, subscription)
    } else { // else add it
      state.data.push(subscription)
    }
  },
  unloadSubscription (state, subscriptionId) {
    var existingElementIndex = state.data.findIndex((el) => el.uid === subscriptionId)
    if (existingElementIndex > -1) {
      state.data.splice(existingElementIndex, 1)
    }
  },
}
